import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './index'
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant'

export default function createAppStore() {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      process.env.NODE_ENV !== 'production'
        ? getDefaultMiddleware().concat(reduxImmutableStateInvariant())
        : getDefaultMiddleware(),
    devTools: process.env.NODE_ENV !== 'production',
  })
}
